/* global $ */
import React, { Component } from 'react';
import './preview/Preview.css';
import {Splash} from './preview/Splash';
import {Verification} from './preview/Verification';
import {Loading} from './preview/Loading';
import {Interstitial} from './preview/Interstitial';
import {Success} from './preview/Success';
import GeneralBackground from './../images/general.jpg';
import CoffeeBackground from './../images/coffee.jpg';
import ClothingBackground from './../images/clothing.jpg';
import RestaurantBackground from './../images/restaurant.jpg';

export class PreviewWindow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0
        };

        this.showTitle = this.showTitle.bind(this);
        this.getBackground = this.getBackground.bind(this);
    };

    componentDidMount() {
        var self = this;
        $('#preview').modal('setting', {
            onShow : function () {
                $(this).css({
                    'top': '0',
                    'bottom': '0',
                    'left': '0',
                    'right': 0
                });
                self.showSplash();
            },
            blurring: true
        });
    }

    getBackground() {
        var style= this.props.fieldValues["style"];
        var background;
        if (style !== "undefined" && style !== "noimage" && style !== null && style.length !== 0) {
            background = {backgroundImage: "url(" + this.props.fieldValues["style"] + ")"};
        }
        return background;
    }

    showTitle() {
        var serviceName = this.props.fieldValues.serviceName;
        if (serviceName !== null & serviceName !== "") {
            return true;
        } else {
            return false;
        }
    }

    showSplash() {
        this.setState({
            page : 0
        });
    };

    showVerification() {
        this.setState({
            page : 1
        })
    };

    showLoading() {
        this.setState({
            page : 2
        })
    }


    showInterstitial() {
        this.setState({
            page : 3
        })
    }


    showSuccess() {
        this.setState({
            page : 4
        })
    }

    clearClasses() {
        $('#previewProgress').removeClass();
        $('#previewProgress').addClass('progress');
        $('#step_20').removeClass();
        $('#step_40').removeClass();
        $('#step_60').removeClass();
        $('#step_80').removeClass();
        $('#step_100_5').removeClass();
    }


    displayFacebook() {
        if (this.props.fieldValues.facebookLink !== null &
            this.props.fieldValues.facebookLink !== "") {
            return "inline-block";
        }
        return "none";
    }

    displayFoursquare() {
        if (this.props.fieldValues.foursquareLink !== null &
            this.props.fieldValues.foursquareLink !== "") {
            return "inline-block";
        }
        return "none";
    }

    displayTwitter() {
        if (this.props.fieldValues.twitterLink !== null &
            this.props.fieldValues.twitterLink !== "") {
            return "inline-block";
        }
        return "none";
    }

    showPage() {
        // eslint-disable-next-line
        switch (this.state.page) {
            case 0:
                this.clearClasses();
                $('#previewProgress').addClass('step_20');
                $('#step_20').addClass('selected');
                return <Splash getBackground={this.getBackground.bind(this)}
                               showTitle={this.showTitle}
                               showMessage={this.props.showMessage}
                               fieldValues={this.props.fieldValues} />;
            case 1:
                this.clearClasses();
                $('#previewProgress').addClass('step_40');
                $('#step_40').addClass('selected');
                return <Verification getBackground={this.getBackground.bind(this)}
                                     showTitle={this.showTitle}
                                     showMessage={this.props.showMessage}
                                     fieldValues={this.props.fieldValues} />;
            case 2:
                this.clearClasses();
                $('#previewProgress').addClass('step_60');
                $('#step_60').addClass('selected');
                return <Loading lang={this.props.lang}
                               showMessage={this.props.showMessage} />;
            case 3:
                this.clearClasses();
                $('#previewProgress').addClass('step_80');
                $('#step_80').addClass('selected');
                return <Interstitial lang={this.props.lang}
                               showMessage={this.props.showMessage}
                               fieldValues={this.props.fieldValues} />;
            case 4:
                this.clearClasses();
                $('#previewProgress').addClass('step_100_5');
                $('#step_100_5').addClass('selected');
                if (this.props.fieldValues.redirectUrl !== null && this.props.fieldValues.redirectUrl !== "") {
                    return <div id="redirectURLContainer"><h3>{this.props.fieldValues.redirectUrl}</h3></div>;
                }
                return <Success getBackground={this.getBackground.bind(this)}
                                showTitle={this.showTitle}
                                showMessage={this.props.showMessage}
                                fieldValues={this.props.fieldValues}
                                displayFacebook={this.displayFacebook.bind(this)}
                                displayFoursquare={this.displayFoursquare.bind(this)}
                                displayTwitter={this.displayTwitter.bind(this)} />;
        }
    };

    render() {
        return(
            <div id="preview" className="ui modal fullscreen">
                <i className="close icon"></i>
                <div className="previewContainer scrolling content">
                    <h1 className="purple">{this.props.showMessage('message_17_01')}</h1>
                    <div id="previewProgress" className="progress step_20" lang={this.props.lang}>
                        <div>
                            <div onClick={this.showSplash.bind(this)}>
                                <span id="step_20">{this.props.showMessage('message_17_02')}</span>
                            </div>
                            <div onClick={this.showVerification.bind(this)}>
                                <span id="step_40">{this.props.showMessage('message_17_03')}</span>
                            </div>
                            <div onClick={this.showLoading.bind(this)}>
                                <span id="step_60">{this.props.showMessage('message_17_04')}</span>
                            </div>
                            <div onClick={this.showInterstitial.bind(this)}>
                                <span id="step_80">{this.props.showMessage('message_17_05')}</span>
                            </div>
                            <div onClick={this.showSuccess.bind(this)}>
                                <span id="step_100_5">{this.props.showMessage('message_17_06')}</span>
                            </div>
                        </div>
                    </div>
                    <div className="mobilePreview">
                        <div className="pageContainer">
                            {this.showPage()}
                        </div>
                    </div>
                    <div className="desktopPreview">
                        <div className="pageContainer">
                                {this.showPage()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/PreviewWindow.jsx